angular.module('AccountingBoxApp')
.directive('absort', function() {
return {
    restrict: 'A',
    transclude: true,
    replace:true,
    scope:{
      order:'=',
     ordername:'=',
        reload:'&'
    },
    template :
      '<th ng-click="onClick()" ng-class="(order.by == ordername) ? (order.reverse ? \'sorting_desc\': \'sorting_asc\') : \'sorting\'">'+
        '<span ng-transclude></span>'+
      '</th>',
    link: function(scope, element, attrs) {
   // scope.ordername= attrs.ordername;
  // console.log(scope.order.by);
    //  console.log(scope.ordername);
      scope.onClick = function () {
        if( scope.ordername === scope.order.by ) {
           scope.order.reverse = !scope.order.reverse;
        } else {
          scope.order.by = scope.ordername ;
          scope.order.reverse = false;
        }
          if(scope.reload){
              scope.reload();
          }
      };
    }
};
});
